export default __webpack_public_path__ + "static/media/eastern-market-map.77ddec60.png";